var TabCommentsModule = /** @class */ (function () {
    function TabCommentsModule() {
    }
    return TabCommentsModule;
}());
export { TabCommentsModule };
